import * as React from 'react'

import { styled } from '~/styled'

import { useBannerContext } from '../BannerContext'

const Container = styled(
  'div',
  {
    base: ['w-31/50', 'grow'],
    variants: {
      size: {
        sm: ['p-4'],
        md: ['p-6', 'pr-8']
      }
    }
  },
  {
    enabledResponsiveVariants: true
  }
)

export const BannerRegularContent = (
  props: React.ComponentProps<typeof Container>
) => {
  const { size } = useBannerContext()

  return <Container size={size} {...props} />
}

BannerRegularContent.displayName = 'BannerRegularContent'
